import { render, staticRenderFns } from "./jxf.vue?vue&type=template&id=2e2e63c8"
import script from "./jxf.vue?vue&type=script&lang=js"
export * from "./jxf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports